import { useT } from '@transifex/react'
import { useDispatch } from 'react-redux'
import { FulfilmentDetail } from '../../../../../../models/fulfilment'
import { useAppSelector } from '../../../../../../state/hooks'
import {
  openFulfilmentLineItemPopover,
  selectOpenFulfilmentPopoverLineItemId,
} from '../../../../../../state/slices/uiStateSlice'
import {
  AddressErrorsStatus,
  AddressErrorStatusTypes,
} from '../../popover/hooks/useFulfillmentHelper'
import { EditAddressButtons } from '../EditAddressButton/EditAddressButton.type'
import { useAddressModalHandlers } from '../hooks/useAddressModalHandlers'

export interface EmptyAddressProps {
  isModalOpeningOnError?: boolean
  hasError: boolean
  addressStatus: AddressErrorStatusTypes
  lineItemLocalId?: string
  onSave?: (fulfillmentDetails: FulfilmentDetail[]) => void
}

type EmptyAddressButtonType = 'add' | 'addShipping'

export const useEmptyAddressModel = ({
  addressStatus,
  lineItemLocalId,
  onSave,
}: EmptyAddressProps) => {
  const t = useT()
  const dispatch = useDispatch()
  const currentOpenLineItemId = useAppSelector(
    selectOpenFulfilmentPopoverLineItemId
  )

  const buttonType: EmptyAddressButtonType =
    addressStatus === AddressErrorsStatus.EMPTYSHIPPING_EMPTYBILLING
      ? EditAddressButtons.add
      : EditAddressButtons.addShipping

  const shouldOpenFulfilmentPopover =
    addressStatus === AddressErrorsStatus.EMPTYSHIPPING_CORRECTBILLING ||
    addressStatus === AddressErrorsStatus.EMPTYSHIPPING_INCORRECTBILLING

  const { openAddressModal } = useAddressModalHandlers({
    type: buttonType,
    onSave,
  })

  const openFulfillmentPopover = () => {
    const targetLineItemId = lineItemLocalId || currentOpenLineItemId
    if (targetLineItemId) {
      dispatch(openFulfilmentLineItemPopover(targetLineItemId))
    }
  }

  return {
    addAddressLabel: t('Add address', { _context: 'Action link' }),
    buttonType,
    openAddressModal,
    openFulfillmentPopover,
    shouldOpenFulfilmentPopover,
    title: t('Shipping & billing address', { _context: 'Section title' }),
  }
}
